<template>
  <div class="login">
    <br>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <div class="text-center mb-2">
            <h2>
              <span class="login-title">
                <v-icon color="blue-grey darken-2">mdi mdi-account-key</v-icon>
              </span><span class="blue-grey--text text--darken-2">Inicio de sesión</span>
            </h2>
          </div>
          <v-card class="elevation-12">
              <v-card-text class="pb-0">
                <h3>Por favor inicia sesión con tu correo intitucional y tu contraseña.</h3>
                <v-form>
                  <v-text-field
                    v-model="email"
                    prepend-icon="mdi-email"
                    label="Email"
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    prepend-icon="mdi-lock"
                    label="Contraseña"
                    type="password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn 
                  block
                  class="blue-grey darken-2 white--text" 
                  :loading="loading"
                  :disabled="loading" 
                  @click="login()"
                >Acceder</v-btn>
              </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
  import { mapMutations } from 'vuex'
  import firebase from 'firebase'
  export default {
    name: 'Login',
    data(){
      return{
        email: "",
        password: "",
        loading: false
      }
    },
    methods:{
      login(){
        this.loading = true
        firebase.auth().signInWithEmailAndPassword(this.email, this.password)
        .then(
          (user) => {
            this.loading = false
            this.$router.replace('admin')
          }, 
          (error) => {
            this.loading = false
            this.$store.commit('dialogMSG', {flag: true, msg:error.message})
          } 
            
        )
      }
    },
    created(){
      if(firebase.auth().currentUser){
        this.$router.replace('home')
      }
    }
  };
</script>
